module.exports = __webpack_public_path__ + "img/dingbu.8334f6d7.png";